import { useTranslation } from "react-i18next";
import { Shield, Mail } from "lucide-react";

const LayoutFooter = () => {
  const { t } = useTranslation();
  return (
    <footer className="mt-12 pt-6 flex flex-col items-center gap-2" style={{ borderTop: "1px solid var(--lm-border)" }}>
      <div className="flex items-center gap-5">
        <a href="/privacy" className="inline-flex items-center gap-1.5 text-xs transition-colors"
          style={{ color: "var(--lm-ink-3)" }}
          onMouseEnter={e => (e.currentTarget.style.color = "var(--lm-ink-2)")}
          onMouseLeave={e => (e.currentTarget.style.color = "var(--lm-ink-3)")}>
          <Shield className="w-3.5 h-3.5" />{t('sidebar.footer.privacy')}
        </a>
        <a href="mailto:support@mawered.com" className="inline-flex items-center gap-1.5 text-xs transition-colors"
          style={{ color: "var(--lm-ink-3)" }}
          onMouseEnter={e => (e.currentTarget.style.color = "var(--lm-ink-2)")}
          onMouseLeave={e => (e.currentTarget.style.color = "var(--lm-ink-3)")}>
          <Mail className="w-3.5 h-3.5" />{t('sidebar.footer.support')}
        </a>
      </div>
      <p className="text-xs" style={{ color: "var(--lm-border-2)" }}>{t('sidebar.footer.copyright')}</p>
    </footer>
  );
};

export default LayoutFooter;
